// src/components/GameOverScreen.js
import React from 'react';
import { RotateCcw } from 'lucide-react';
import AyseLadyLogo from './AyseLadyLogo';

const GameOverScreen = ({ score, catInfo, onResetGame, onBackToMenu }) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-400 to-pink-400 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl p-8 text-center max-w-md w-full">
        <AyseLadyLogo />
        <div className="text-6xl mb-4">😿</div>
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Oyun Bitti!</h2>
        <p className="text-gray-600 mb-6">
          Skorun: {score}/200<br/>
          Kedi seviyesi: {catInfo.stage}
        </p>
        <div className="space-y-3">
          <button 
            onClick={onResetGame}
            className="w-full bg-purple-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-purple-600 transition-colors"
          >
            <RotateCcw className="inline mr-2" size={20} />
            Tekrar Oyna
          </button>
          <button 
            onClick={onBackToMenu}
            className="w-full bg-gray-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-600 transition-colors"
          >
            Ana Menü
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameOverScreen;